import React, { useEffect, useState } from 'react'

const CustomDatePicker = ({
    label,
    name,
    onchange,
    error,
    value,
    disabled,
    style
}) => {

    const [dateValue, setDateValue] = useState(value || "");

    useEffect(() => {
        setDateValue(value || "");
    }, [value]);

    const handleChange = (e) => {
        const inputValue = e.target.value;
        onchange?.(name, inputValue);
        setDateValue(inputValue);
    };

    return (
        <div className='swift-date-wrapper'>
            {label && (<p>{label}</p>)}
            <input
                className=""
                type="date"
                value={dateValue}
                onChange={handleChange}
                style={{ ...style, opacity: disabled ? 0.5 : 1 }}
                disabled={disabled}
            />
            <p className='error-text'>{error}</p>
        </div>
    )
}

export default CustomDatePicker
